document.addEventListener('click', (event) => {
  // 1. Check if the click was on a summary or inside a summary
  const summary = event.target.closest('summary');
  if (!summary) return;

  const currentDetails = summary.parentElement;
  
  // 2. Only run logic if the accordion is currently CLOSED (meaning it's about to open)
  if (!currentDetails.hasAttribute('open')) {
    // Find all other details tags in the same section
    const allDetails = currentDetails.closest('.grid__item').querySelectorAll('details');

    allDetails.forEach((detail) => {
      if (detail !== currentDetails) {
        // Close the tag
        detail.removeAttribute('open');
        // Fix the ARIA state for accessibility
        const otherSummary = detail.querySelector('summary');
        if (otherSummary) {
          otherSummary.setAttribute('aria-expanded', 'false');
        }
      }
    });
    
    // Set the clicked one to true
    summary.setAttribute('aria-expanded', 'true');
  }
});